<template>
    <Teleport to="body">
        <Transition name="fade">
            <div
                v-if="open"
                @click="emit('close')"
                class="fixed bottom-0 left-0 top-0 z-50 h-[100dvh] w-full bg-white md:bg-black/15"></div>
        </Transition>
        <Transition name="slideright">
            <aside
                v-if="open"
                class="fixed bottom-0 right-0 top-0 z-50 flex h-[100dvh] w-full flex-col overflow-hidden bg-white shadow-md md:w-[464px]"
                role="complementary">
                <header class="flex shrink-0 items-center justify-between p-5">
                    <h2 class="text-lg" v-if="$slots.title">
                        <slot name="title">Sidebar</slot>
                    </h2>
                    <button
                        @click="emit('close')"
                        class="group flex items-center leading-[28px] tracking-[0.8px]"
                        type="button">
                        {{ $snippets['headless.sidebar.close'] }}
                        <ArrowRightIcon class="ml-3 size-5 stroke-2 duration-300 group-hover:translate-x-1" />
                    </button>
                </header>

                <div class="flex min-h-0 flex-1 flex-col">
                    <div v-if="$slots.content" class="min-h-0 flex-1 overflow-y-auto" :class="{ 'pb-0': $slots.footer }">
                        <slot name="content" />
                    </div>

                    <footer v-if="$slots.footer" class="shrink-0">
                        <slot name="footer" />
                    </footer>
                </div>
            </aside>
        </Transition>
    </Teleport>
</template>

<script setup lang="ts">
    import { ArrowRightIcon } from '@heroicons/vue/24/outline';

    const props = defineProps({
        title: Object | String,
        wishlist: String,
        open: {
            type: Boolean,
            default: false,
        },
        cart: Boolean,
        cartCount: Number,
    });

    watch(props, value => {
        if (process.client) {
            if (props.open) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        }
    });

    const emit = defineEmits(['close']);
</script>
